export default {
	process: {
		empty: {
			title: "Noch keine Prozesse",
			hint: "Starten Sie einen Prozess, den das Projekt definiert.",
		},
		// Die Suche und die Status-Chips über der Liste.
		filter: {
			search: "Prozesse suchen…",
			status: "Status",
			clear: "Filter zurücksetzen",
			found: "{n} gefunden",
			noResults: {
				title: "Keine passenden Prozesse",
				hint: "Nichts passt zu dieser Suche und diesen Filtern. Versuchen Sie einen anderen Begriff, oder setzen Sie die Filter zurück.",
			},
		},
		new: "Neuer Prozess",
		create: "Prozess erstellen",
		createFailed: "Der Prozess konnte nicht erstellt werden.",
		base: "Prozess (aus dem Designer)",
		name: "Instanzname",
		nameHint: "Leer lassen für einen automatisch vergebenen Namen.",
		// Wie er heißt: sein Name, seine Beschreibung und sein Alias (`EditProcessDialog`).
		edit: {
			action: "Details bearbeiten",
			title: "Prozess bearbeiten",
			saved: "{name} gespeichert.",
		},
		// Für wen ein Prozess über die Rolle hinaus freigegeben ist (`ProcessAccessDialog` und der
		// Abschnitt im Startdialog). „Mitarbeiten“ heißt: Fragen beantworten und Daten ändern.
		access: {
			action: "Freigegeben für",
			title: "Freigegeben für",
			hint: "Wessen Rolle Prozesse anzeigt, sieht diesen ohnehin. Hier wird er für Personen freigegeben, deren Rolle das nicht tut: zum Ansehen, oder zum Ansehen und Mitarbeiten — Fragen beantworten und Daten ändern.",
			startHint:
				"Von Anfang an für Personen freigeben, deren Rolle ihnen keine Prozesse anzeigt.",
			none: "Für niemanden über die Rolle hinaus freigegeben.",
			grants: {
				read: "Darf ansehen",
				read_write: "Darf ansehen und mitarbeiten",
			},
			grant: "Zugriff",
			grantFor: "Zugriff für {name}",
			person: "Person",
			personPlaceholder: "Nach Name oder E-Mail suchen…",
			nobodyLeft: "Niemand gefunden.",
			add: "Freigeben",
			remove: "Freigabe für {name} aufheben",
			shared: "Für {name} freigegeben.",
			unshared: "Für {name} nicht mehr freigegeben.",
		},
		// A process another one spawned, in the list: started by that process, not by its person.
		spawnedBy: {
			note: "Von einem Prozess · {date}",
			title: "Vom Prozess „{name}“ gestartet",
		},
		deleteConfirm: "{name} löschen?",
		deleteNote:
			"Sein gespeicherter Zustand und seine Logs werden mit gelöscht. Das lässt sich nicht rückgängig machen.",
		stopNamed: "{name} stoppen",
		column: {
			process: "Prozess",
			status: "Status",
			definition: "Definition",
			dataobjects: "Datenobjekte",
			created: "Erstellt",
			version: "Version",
			resume: "Beim Neustart",
		},
		toast: {
			stopped: "{name} gestoppt.",
			archived: "{name} archiviert.",
			unarchived: "Archivierung von {name} aufgehoben.",
			deleted: "{name} gelöscht.",
			restartRuleSaved: "Neustart-Regel gespeichert.",
			upgraded: "{name} wird auf {version} aktualisiert.",
		},
		archive: "Archivieren",
		unarchive: "Archivierung aufheben",
		archived: "Archiviert",
		selection: {
			row: "{name} auswählen",
			clear: "Auswahl aufheben",
			all: "Alle auswählen",
			none: "Auswahl aufheben",
			count: "{n} ausgewählt",
		},
		bulk: {
			archive: "Archivieren",
			deleteConfirm: "{n} Prozesse löschen?",
			archived: "{n} Prozess archiviert. | {n} Prozesse archiviert.",
			deleted: "{n} Prozess gelöscht. | {n} Prozesse gelöscht.",
			archiveFailed:
				"{n} Prozess konnte nicht archiviert werden. | {n} Prozesse konnten nicht archiviert werden.",
			deleteFailed:
				"{n} Prozess konnte nicht gelöscht werden. | {n} Prozesse konnten nicht gelöscht werden.",
		},
		error: {
			showDetails: "Details anzeigen",
			hideDetails: "Details ausblenden",
			copy: "Kopieren",
			copied: "Kopiert",
			showFor: "Fehlerursache für {name}",
		},
		status: {
			starting: "Startet",
			running: "Läuft",
			stopped: "Gestoppt",
			failed: "Fehlgeschlagen",
			archived: "Archiviert",
		},
		restartRule: {
			label: "Neustart-Regel",
			no: "Kein Neustart",
			byUser: "Manuell (durch Benutzer)",
			unlessStopped: "Immer, außer nach Stopp",
			onFailure: "Bei Fehler",
			onFailureWithRetries: "Bei Fehler ({n}x)",
			retries: "Maximale Wiederholungen",
			retriesHelp:
				"Wie oft er nach einem Fehler neu gestartet wird. Leer lassen für unbegrenzt.",
			retriesInvalid:
				"Geben Sie eine ganze Zahl ab 1 ein, oder lassen Sie das Feld leer für unbegrenzt.",
		},
		restartRuleAction: "Neustart-Regel…",
		// Die Version, auf der ein Prozess läuft: das Release, auf dem er erstellt wurde, oder `wip`.
		version: {
			wipHint:
				"Folgt dem aktuellen Arbeitsstand des Projekts. Ein Neustart nutzt seinen neuesten Build.",
			releaseHint:
				"Auf Release {version} erstellt; der Prozess bleibt darauf, auch wenn der Dataspace auf eine andere Version wechselt.",
			outdated: "Alte Version",
			outdatedHint:
				"Der Dataspace läuft jetzt auf {current}, dieser Prozess noch auf {version}. Aktualisieren Sie ihn, um ihn nachzuziehen.",
			outdatedHintUnnamed:
				"Der Dataspace ist jetzt auf einer anderen Version, dieser Prozess läuft noch auf {version}. Aktualisieren Sie ihn, um ihn nachzuziehen.",
		},
		// Was ein Neustart mit dem gespeicherten Zustand des Prozesses macht (siehe `utils/process/resume.ts`).
		resume: {
			unsupported: {
				label: "Build ohne Fortsetzungsfunktion — Neustart beginnt von vorn",
				hint: "Dieser Build wurde erstellt, bevor Prozesse dort weitermachen konnten, wo sie angehalten wurden. Ein Neustart startet ihn deshalb von vorn, und was er gerade hält, geht verloren.",
			},
			blockedHint:
				"Er wird nicht von selbst neu gestartet. Ein Neustart von Hand versucht erneut fortzusetzen; er beginnt nicht von vorn.",
			blockedBy: {
				format_unsupported: "Blockiert: Zustandsformat unbekannt",
				snapshot_invalid: "Blockiert: Zustand beschädigt",
				schema_mismatch: "Blockiert: Datenmodell geändert",
				dataobject_unrestorable: "Blockiert: Daten nicht wiederherstellbar",
				restore_error: "Blockiert: Wiederherstellung fehlgeschlagen",
				restore_failed: "Blockiert: Wiederherstellung fehlgeschlagen",
				resume_state_missing: "Blockiert: Zustand fehlt",
				unstable: "Blockiert: scheitert immer wieder",
				unknown: "Blockiert: {code}",
			},
			blockedWhy: {
				format_unsupported:
					"Der gespeicherte Zustand hat ein Format, das die Engine dieses Builds nicht kennt.",
				snapshot_invalid: "Die Engine konnte den gespeicherten Zustand nicht lesen.",
				schema_mismatch:
					"Der gespeicherte Zustand wurde für ein anderes Datenmodell erstellt, als dieser Build hat.",
				dataobject_unrestorable:
					"Eines der Datenobjekte des Prozesses ließ sich nicht aus dem gespeicherten Zustand aufbauen.",
				restore_error:
					"Die Engine ist beim Zurücklesen des gespeicherten Zustands gescheitert. Das Log des Prozesses nennt Einzelheiten.",
				restore_failed:
					"Der Prozess endete beim Zurücklesen seines gespeicherten Zustands, ohne zu sagen, warum. Sein Log nennt vielleicht Einzelheiten.",
				resume_state_missing:
					"Der gespeicherte Zustand fehlt oder ist beschädigt, und die vorherige Kopie ebenso. Er wird nicht durch einen Neustart von vorn ersetzt, weil alles verloren ginge, was der Prozess hielt.",
				unstable:
					"Er hat sich dreimal hintereinander kurz nach dem Zurücklesen seines gespeicherten Zustands beendet und wird deshalb nicht mehr von selbst neu gestartet.",
				unknown: "Die Engine meldete „{code}“ beim Zurücklesen des gespeicherten Zustands.",
			},
			lost: {
				label: "Gespeicherter Zustand nicht genutzt",
				hint: "Er bekam beim Start seinen gespeicherten Zustand und begann trotzdem von vorn.",
			},
			stale: {
				label: "Setzt mit älterem Zustand fort",
				hint: "Sein neuester Zustand ließ sich nicht speichern, weil er zu groß geworden ist oder der Server ihn nicht schreiben konnte. Ein Neustart setzt deshalb beim Zustand davor fort.",
			},
			saved: {
				label: "Setzt dort fort, wo er stoppte",
				hint: "Ein Neustart setzt beim zuletzt gespeicherten Zustand fort.",
			},
			none: {
				label: "Noch nichts gespeichert",
				hintRunning:
					"Er speichert seinen Zustand, sobald er sich ändert; bisher ist nichts abgelegt.",
				hintStopped:
					"Vor dem Stopp wurde nichts abgelegt, daher beginnt ein Neustart von vorn.",
			},
			savedAt: "Gespeichert am {when}.",
			// Ein Lauf, der seinen Zustand bestmöglich zurückgelesen hat: keines, eines oder n Elemente passten nicht mehr.
			migrated: {
				label: "Bestmöglich fortgesetzt: nichts verworfen | Bestmöglich fortgesetzt: {n} Element verworfen | Bestmöglich fortgesetzt: {n} Elemente verworfen",
				hint: "Dieser Lauf hat seinen gespeicherten Zustand bestmöglich zurückgelesen, und alles passte noch. | Dieser Lauf hat seinen gespeicherten Zustand bestmöglich zurückgelesen, und {n} Element passte nicht mehr zu dieser Version. | Dieser Lauf hat seinen gespeicherten Zustand bestmöglich zurückgelesen, und {n} Elemente passten nicht mehr zu dieser Version.",
				title: "Bestmöglich fortgesetzt",
				body: "Der gespeicherte Zustand wurde zurückgelesen, soweit er zu dieser Version passt, und alles passte. | Der gespeicherte Zustand wurde zurückgelesen, soweit er zu dieser Version passt: {n} Element passte nicht mehr und wurde verworfen. Das Log des Prozesses nennt es. | Der gespeicherte Zustand wurde zurückgelesen, soweit er zu dieser Version passt: {n} Elemente passten nicht mehr und wurden verworfen. Das Log des Prozesses nennt sie.",
			},
		},
		// Einen Prozess auf die Version bringen, auf der sein Dataspace läuft.
		upgrade: {
			action: "Auf aktuelle Version aktualisieren",
			title: "{name} auf {version} aktualisieren?",
			titleUnnamed: "{name} auf die Version des Dataspace aktualisieren?",
			note: "Der Prozess wird angehalten und startet dann auf der Version des Dataspace neu. Seine gespeicherten Daten übernimmt er bestmöglich: Was nicht mehr zu dieser Version passt, wird verworfen, und sein Log nennt, was. Hat der Build dieser Version keine Fortsetzungsfunktion, gibt es keinen Zustand zum Mitnehmen, und der Prozess beginnt von vorn. Das lässt sich nicht rückgängig machen — ein Prozess kann nicht auf seine alte Version zurück.",
			confirm: "Aktualisieren",
			refused: {
				restartNotAllowed:
					"Seine Neustart-Regel ist „Kein Neustart“, und eine Aktualisierung ist ein Neustart. Ändern Sie zuerst die Regel.",
				archived:
					"Ein archivierter Prozess kann nicht aktualisiert werden. Heben Sie zuerst die Archivierung auf.",
				alreadyCurrent: "Er läuft bereits auf der Version des Dataspace.",
				versionNotBuilt:
					"Die Version des Dataspace hat keinen Build, der laufen könnte. Erstellen Sie zuerst einen Build dieser Version.",
				forbidden: "Sie dürfen die Prozesse dieses Dataspace nicht verwalten.",
				gone: "Diesen Prozess gibt es nicht mehr.",
			},
		},
		// Ein laufender Prozess, gestartet bevor sich die Umgebung seines Dataspace geändert hat.
		env: {
			outdated: "Alte Umgebung",
			changedSince: "Seit dem Start geändert: {names}",
			changedSinceUnnamed: "Seine Umgebung hat sich seit dem Start geändert",
		},
		restart: "Neu starten",
		stop: "Stoppen",
		// Der Alternis-Chat. Die meisten Texte sind die von alternis_voip
		// (client/public/locales/de.json, dev @ 128cfc3).
		chat: {
			title: "Chat",
			empty: "Noch keine Nachrichten",
			emptyNote:
				"Was im Anruf gesprochen wird, erscheint hier — transkribiert und übersetzt.",
			waiting: "Noch kein Anruf",
			waitingNote:
				"Das Gespräch erscheint hier, sobald der Prozess mit einem Anruf verbunden ist.",
			transcribing: "Transkription läuft…",
			translating: "Übersetzung läuft…",
			someFailed: "Etwas ist schiefgegangen",
			state: {
				active: "Live",
				passive: "Passiv",
				inactive: "Beendet",
			},
			role: "Disponent | Anrufer | Anrufer {caller}",
			summary: "Zusammenfassung",
			summaryNote: "KI-generierte Zusammenfassung — überprüfen Sie kritische Informationen.",
			messagesNote:
				"KI-gestützte Transkription, Übersetzung und Synthese — überprüfen Sie kritische Informationen.",
			showMore: "Mehr anzeigen",
			showLess: "Weniger anzeigen",
			follow: "Dem Gespräch folgen",
			language: {
				search: "Sprachen suchen…",
				noMatch: "Keine Sprache passt.",
				detect: "Automatisch erkennen",
				mentioned: "Erwähnte Sprachen",
				other: "Alle Sprachen",
				locked: "Sprache festgelegt — die automatische Erkennung ändert sie nicht. Klicken, um die Erkennung zuzulassen.",
				unlocked:
					"Erkannte Sprache — die Erkennung kann sie noch ändern. Klicken, um sie festzulegen.",
				lockedReadonly: "Sprache festgelegt — die automatische Erkennung ändert sie nicht.",
				unlockedReadonly: "Erkannte Sprache — die Erkennung kann sie noch ändern.",
			},
			play: {
				play: "Übersetzung für den Anrufer abspielen",
				again: "Übersetzung erneut abspielen",
				whenReady: "Abspielen, sobald die Übersetzung fertig ist",
				queued: "Wird abgespielt, sobald die Übersetzung fertig ist — klicken zum Abbrechen",
			},
			composer: {
				label: "Antworten",
				write: "Schreiben",
				send: "Senden",
				placeholder: "Schreiben Sie eine Nachricht, die laut vorgelesen wird…",
				groupEmpty: "Diese Gruppe enthält noch keine Prefabs.",
				setLanguageFirst:
					"Legen Sie die Sprache des Disponenten fest, um Prefabs zu verwenden.",
			},
			failed: {
				setLanguage: "Die Sprache konnte nicht geändert werden",
				sendText: "Die Nachricht konnte nicht gesendet werden",
				sendPrefab: "Das Prefab konnte nicht abgespielt werden",
				play: "Die Audiodatei konnte nicht abgespielt werden",
				because: "{action}: {reason}",
				featureDisabled: "Dieser Prozess erlaubt es nicht",
				noSession: "Der Prozess ist mit keinem Anruf verbunden",
				timeout: "Der Prozess hat nicht geantwortet",
			},
		},
		pool: {
			title: "Vorschläge",
			empty: "Keine Vorschläge offen.",
			applyFailed: "Der Vorschlag konnte nicht übernommen werden.",
			/* Zwischen dem besten Wert eines Felds und den anderen. */
			or: "oder",
			/* Ein Wert, den der Prozess als nicht bekannt markiert hat. */
			unknown: "Unbekannt",
			/* Neben dem Titel: wie viele Felder offen sind. */
			count: "{n} offen",
			/* Auf der Karte eines Felds: was es jetzt enthält. */
			now: "Jetzt: {value}",
			/* Die Frage, die nach dem Feld fragt, unter seinem Pfad. */
			inQuestion: "Gefragt in „{question}“",
			/* Ein Wert, wie ein Screenreader ihn nennt: was er ist und wohin er geht. */
			apply: "{value}, setzen als {target}",
			/* Nach den ersten drei Werten: der Rest, und ihn wieder einklappen. */
			more: "+{n} weitere",
			fewer: "Weniger",
			/* Eine feste Karte des Pools, zu der es noch keinen Vorschlag gibt. */
			waitingForSuggestion: "Noch kein Vorschlag.",
			/* Eine feste Karte, deren Wert übernommen wurde, in ihrer Fußzeile. */
			taken: "Wert gesetzt",
			/* On a card whose value was just set: what it held before. */
			before: "Vorher:",
			/* The offer block's action, at its end. */
			use: "Übernehmen",
			/* Over the alternatives of a field's best value. */
			alternatives: "Alternativen",
			dismiss: "Vorschläge für {target} verwerfen",
			/* Übernommen, und vom Prozess noch nicht bestätigt. */
			waiting: "Warten auf den Prozess…",
			/* Bestätigt: auf der Karte, und für einen Screenreader. */
			settled: "Auf {value} gesetzt",
			announce: "{target} auf {value} gesetzt",
			notTaken: "Der Prozess hat diesen Wert nicht übernommen.",
			/* Der Prozess hat den Wert abgelehnt und gesagt, warum. */
			refused: "Der Prozess hat diesen Wert nicht übernommen: {reason}",
			/* Unter den Werten: warum — die eigene Begründung eines Werts, sonst seine Herkunft. */
			source: {
				process: "Vom Prozess vorgeschlagen",
				model: "Vom Assistenten vorgeschlagen",
				provider: "Aus einer Datenquelle",
			},
		},
		notifications: {
			/* Der Bereich der Benachrichtigungen. */
			region: "Benachrichtigungen",
			dismiss: "Benachrichtigung schließen",
			fold: "Benachrichtigungen einklappen",
			/* Die eingeklappte Pille: eine Zeile mit der Überschrift der aktuellen. */
			unfold: "Benachrichtigungen anzeigen ({n}): {title}",
			// Solange hinter der angezeigten etwas wartet: die Zeit, bis es kommt. Nur eine Karte ohne
			// Titel sagt es; bei einer mit Titel benennt der Titel den Countdown.
			progress: "Zeit bis zur nächsten Benachrichtigung",
			/* Das Blättern der Karte, durch alle in der Reihenfolge ihres Eintreffens. */
			previous: "Vorherige Benachrichtigung",
			next: "Nächste Benachrichtigung",
			position: "{n} von {total}",
			/* Auf der Karte und der Pille: wie viele eingetroffen und noch nicht gezeigt sind. */
			waiting: "+{n} neu",
			/* Was ein Screenreader sagt, wenn zu einer anderen geblättert wird. */
			stepped: "{n} von {total}: {title}",
			/* Eine Benachrichtigung ohne Titel und ohne Text. */
			untitled: "Benachrichtigung",
			/* Was ein Screenreader beim Eintreffen sagt — einen Fehler sofort, den Rest in einer Pause. */
			announce: "Neue Benachrichtigung: {title}",
			announceError: "Fehler: {title}",
			announceMany: "{n} neue Benachrichtigungen",
		},
		view: {
			needsManage:
				"Ihre Rolle erlaubt es nicht, Prozesse zu stoppen, neu zu starten oder ihre Neustartregel zu ändern.",
			backToProcesses: "Zurück zu den Prozessen",
			// Das Raster, in dem die Panels liegen: wie ein Screenreader jeden Teil davon nennt.
			column: { left: "linke Spalte", middle: "mittlere Spalte", right: "rechte Spalte" },
			align: { top: "oben", bottom: "unten" },
			slot: "Panels, {column}, {align}",
			resizeColumns: "Breite der {before} und der {after}",
			resizeRows: "Höhe von oben und unten in der {column}",
			questionsOrHistory: "Fragen oder ihr Verlauf",
			questionTabs: "Fragen-Tabs",
			closeTab: "{name} schließen",
			closeLogs: "Log schließen",
			resizeLogs: "Höhe des Logs",
			graphly: "Graphly",
			graphlyPlaceholder: "Warten auf Prozessdaten…",
			questions: "Fragen",
			lumina: "Lumina",
			luminaLog: "Protokoll",
			luminaSearch: "Suchen…",
			logs: "Logs",
			noLogs: "Noch keine Logausgabe.",
			noDataobjects: "Derzeit keine Datenobjekte.",
			noQuestions: "Derzeit keine Fragen.",
			history: "Verlauf ({count})",
			defaultQuestionTab: "Allgemein",
			onTopGroup: "Angeheftet",
			savedState: "Zeigt den gespeicherten Zustand vom {date} — dieser Prozess läuft nicht.",
		},
		question: {
			completed: "Beantwortet — nur als änderbar markierte Felder nehmen noch Änderungen an",
			/* The two answers to a yes-or-no question. */
			yes: "Ja",
			no: "Nein",
			/* Neben einer Antwort: ob sie schon im Prozess gespeichert ist. */
			status: {
				saved: "Gespeichert",
				saving: "Wird gespeichert…",
				unsent: "Noch nicht gespeichert — Enter drücken oder das Feld verlassen",
				unsentList: "Noch nicht hinzugefügt — Enter drücken oder das Feld verlassen",
			},
			/* Was ein leeres Feld zu tun sagt, nach seiner Art. */
			placeholder: {
				text: "Text eingeben",
				number: "Zahl eingeben",
				choose: "Auswählen…",
				listFree: "Tippen, mit Enter hinzufügen",
				listPick: "Einen oder mehrere wählen",
			},
			/* Eine Liste als Antwort: Chips, eingetippt oder aus den Werten eines Typs gewählt. */
			list: {
				add: "„{value}“ hinzufügen",
				typeToAdd: "Eintrag tippen, dann Enter drücken",
				noMatch: "Kein Wert passt",
				notANumber: "„{value}“ ist keine Zahl — nur Zahlen können hinzugefügt werden",
			},
			/* Ein Datenobjekt als Formular: was einer Teilantwort noch fehlt. */
			form: {
				empty: "Dieses Datenobjekt hat nichts zum Ausfüllen",
				missing: "Noch benötigt: {fields}",
			},
			/* A question its model bound to other people: why its inputs are locked. */
			boundToOthers:
				"Nur die Personen, für die diese Frage bestimmt ist, dürfen sie beantworten.",
			/* Eine NotitiaUser-Eingabe: eine Person des Dataspace, und die Frage, ob der Prozess für sie
			   freigegeben werden soll, wenn sie ihn nicht sieht oder nicht mitarbeiten darf. */
			user: {
				placeholder: "Nach Name oder E-Mail suchen…",
				nobody: "Niemand gefunden.",
				loadFailed: "Die Personen dieses Dataspace konnten nicht geladen werden.",
				cannotSee: "{name} kann diesen Prozess nicht sehen.",
				cannotTakePart: "{name} sieht diesen Prozess, darf aber nicht mitarbeiten.",
				shareTitle: "Prozess für {name} freigeben?",
				shareCannotSee:
					"{name} kann diesen Prozess nicht sehen: Die Rolle zeigt ihn nicht an. Geben Sie ihn frei, oder wählen Sie die Person ohne Freigabe.",
				shareCannotTakePart:
					"{name} sieht diesen Prozess, darf aber laut Rolle nicht mitarbeiten. Erlauben Sie die Mitarbeit, oder wählen Sie die Person ohne Änderung.",
				dontShare: "Ohne Freigabe wählen",
			},
			/* A Location input: its address, a search, and a map whose pin answers it. */
			location: {
				none: "Noch keine Adresse",
				/* A partial answer: the parts it lacks, by the designer's terms. */
				missing: "Noch benötigt: {fields}",
				search: "Adresse suchen",
				searchPlaceholder: "Straße, Hausnummer, Ort",
				searching: "Suche läuft…",
				results: "Gefundene Adressen",
				noResults: "Keine Adresse gefunden",
				searchFailed: "Die Adresssuche ist gerade nicht erreichbar",
				showMap: "Karte anzeigen",
				hideMap: "Karte ausblenden",
				pinHint: "Auf die Karte klicken oder die Nadel ziehen, um den Ort zu setzen",
				approximate: "Ungefähre Lage, aus der Adresse ermittelt",
				placing: "Adresse wird ermittelt…",
				addressFailed:
					"Für diese Stelle wurde keine Adresse gefunden — stattdessen wurden die Koordinaten übernommen",
				map: "Karte für {label}",
				pin: "Ort für {label}",
			},
		},
		history: {
			recorded: "Erfasst {at} · Revision {revision}",
			removed: "Entfernt {at}, bevor sie vollständig war",
		},
	},
};
